import { render, staticRenderFns } from "./summary.vue?vue&type=template&id=4ff3b6ab&scoped=true"
import script from "./summary.vue?vue&type=script&lang=js"
export * from "./summary.vue?vue&type=script&lang=js"
import style0 from "./summary.vue?vue&type=style&index=0&id=4ff3b6ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff3b6ab",
  null
  
)

export default component.exports